import FirebaseSDK from '@/utils/firebaseSDK';
import SampleDetailDialog from '../SampleDetailDialog.vue';

const firebase = new FirebaseSDK();

export default {
    components: { SampleDetailDialog },
    data() {
        return {
            sampleDetailDialog: {
                visible: false,
                isEditMode: false,
            },
        };
    },
    methods: {
        // 範例
        async onSampleDialogDelete(id) {
            await firebase.deleteSample(id);
            await this.updateData(true);
        },
        onSampleDialogClose(action) {
            this.sampleDetailDialog.visible = false;
            this.sampleDetailDialog.isEditMode = false;

            if (typeof action === 'string') {
                this.openedTemplateSno = action;
            } else if (action) return;
            this.updateData();
        },
    },
};
